module.exports = __webpack_public_path__ + "img/ico_reverse.842490d3.svg";